import React from "react";
import { useDispatch, useSelector } from "react-redux";
import useTranslate from "@default/hooks/use-translate";
import {
  mainMenuOpenAction,
  accessibilityMenuOpenAction,
} from "../../app-actions";
import DashedBorder from "@default/general-components/dashed-border";
import LanguageAndAccessibility from "../language-and-accessibility";

const ActionWrapper = () => {
  const dispatch = useDispatch();
  const mainMenuOpen = useSelector((state) => state.appStore.mainMenuOpen);
  const isMobile = useSelector((state) => state.appStore.isMobile);
  const _t = useTranslate();

  return (
    <div className="action-wrapper">
      {isMobile && <LanguageAndAccessibility />}
      <button
        id="close-overlay-menu"
        type="button"
        aria-label={`${_t("accessibility.main_menu")} ${_t(
          "accessibility.close"
        )}`}
        aria-controls="overlay-menu"
        aria-expanded={mainMenuOpen}
        onClick={() => {
          dispatch(mainMenuOpenAction(false));
          dispatch(accessibilityMenuOpenAction(false));
        }}
      >
        <DashedBorder blurredBackdrop />
        <div className="bar" />
        <div className="bar" />
      </button>
    </div>
  );
};

export default ActionWrapper;
